import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['createExceptionToggle', 'exceptionSection', 'exceptionMode', 'customRange']

  connect() {
    this.toggleException();
    this.toggleMode();
  }

  toggleException() {
    this.exceptionSectionTarget.classList.toggle('hidden', !this.createExceptionToggleTarget.checked);
  }

  toggleMode() {
    const selected = this.exceptionModeTargets.find((radio) => radio.checked);
    this.customRangeTarget.classList.toggle('hidden', selected?.value !== 'custom');
  }
}
